import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#FFF",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.167 7.333V5.667a4.167 4.167 0 0 0-8.333 0v1.666M8 11.083v1.667M5.334 16.5h5.333c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.092-1.092c.273-.535.273-1.235.273-2.635v-1.167c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.092-1.092c-.535-.273-1.235-.273-2.635-.273H5.334c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 0 0-1.093 1.092c-.273.535-.273 1.235-.273 2.635V12.5c0 1.4 0 2.1.273 2.635a2.5 2.5 0 0 0 1.093 1.092c.534.273 1.234.273 2.635.273"
    }, null, -1)
  ]))]))
}
export default { render: render }